export default {
  title: '¡Paga Facturas Ahora!',
  subtitle: 'Paga facturas aquí a tus familiares y seres queridos en pocos segundos',
  description: 'Debes contar con una conexión WiFi o datos móviles de navegación para este módulo',
  labelPhone: 'Teléfono o servicio al que deseas que te paguen',
  labelUsaPhone: 'Teléfono de quien deseas solicitar el pago',
  SMS_FAIL: 'No es posible realizar el pago al número o servicio solicitado. Favor de intentar nuevamente.',
  SMS_SUCCESS: 'Se ha enviado un SMS a tu contacto de USA solicitando el pago de tu Factura.',
  PAYMENT_REJECTED_TITLE: '¡Pago rechazado!',
  PAYMENT_REJECTED: 'Lo sentimos, no podemos activar el débito automático mensual a tu tarjeta USA.'
};
